import React, {useState} from 'react';
import {Flexbox, PolyStateToggle} from "../../common/fusion-ui";
import {EventTypes, Keys, Modules} from "../config/AppConfig";
import {getJsonValue} from "../../common/fusion-ui/utils/ReactUtils";
import {useConfig} from "../context/ConfigProvider";
import {printLog} from "../utils/AppUtils";

/**
 * Create an event-type multi-state toggle that uses AppConfig.{@link EventTypes}.
 *
 * @example
 * const [currEvtId, setCurrEvtId] = useState(EventTypes.all.id);
 * <EventTypeToggle
 *    onSwitch={(id, index, text) => {
 *        setCurrEvtId(id);
 * }}/>
 */
const EventTypeToggle = React.memo(({
                                        className = "",
                                        style = {},
                                        onSwitch,
                                    }) => {
    const TAG = "EventTypeToggle";

    const [currEvtId, setCurrEvtId] = useState(EventTypes.all.id);
    const {getConfig} = useConfig();

    return (<>
            <Flexbox className={`${className}`}
                     justifyAt={'start'} alignAt={'center'}
                     wrapSm={'wrap'} alignAtSm={'start'}
                     style={style}>
                <PolyStateToggle
                    className={''}
                    variant={'primary'}
                    bgVariant={'transparent'}
                    rippleVariant={'light'}
                    reverseVariant={'white'}
                    itemClassName={''}
                    itemIconClassName={''}
                    buttonHeight={'26px'}
                    fsVariant={'sm'}
                    defOption={currEvtId}
                    onSwitch={(text, index, item) => {
                        printLog(TAG, 'onSwitch.item:', item, 'text:', text);
                        setCurrEvtId(index);
                        onSwitch(getJsonValue(item, 'id'), text, index);
                    }}>
                    {Object.values(getEventTypes())}
                </PolyStateToggle>
            </Flexbox>
        </>
    );

    function getEventTypes() {
        const currModule = getConfig(Keys.tracker_currPageModule);
        if (currModule == Modules.WebMeeting || currModule == Modules.Meetings) {
            const types = {...EventTypes, expired: {...EventTypes.expired, text: EventTypes.expired.textAlt}};
            // const {ongoing, ...rest} = types;
            // return rest;
            return types;
        } else if (currModule == Modules.Survey || currModule == Modules.DiscussionForum) {
            return EventTypes;
        } else {
            return EventTypes;
        }
    }
});
export default EventTypeToggle;
